$(document).ready(function() {
    /**
     * Delete a single address
     */
    $('body').on('click', '.delete-profile-address', function (e) {
        e.preventDefault();
        let type = $(this).attr('data-type');
        if (type === 'billing') {
            let url = window.config.urls.addresses.billing.delete;
        }
        if (type === 'shipping') {
            let url = window.config.urls.addresses.shipping.delete;
        }
        let id = $(this).attr('data-id');
        window.axios.delete(url, {data: {id}}).then(({data: result}) => {
            if (result.success) {
                location.reload();
            }
            if (!result.success) {
                console.log('Could not delete address');
            }
        })
    });

    /**
     * Edit a single address
     */
    $('.address-table').on('click', '.edit', function (e) {
        e.preventDefault();
        let url = window.config.urls.addresses.editForm;
        let id = $(this).attr('data-id');
        window.axios.post(url + '/' + id, {id}).then(({data: result}) => {
            if (result) {
                $('#edit-fields').html(result);
            }
            if (!result.success) {
                console.log('Could not load address');
            }
        })
    });

});
